import { render, staticRenderFns } from "./echart-bar.vue?vue&type=template&id=2812b6c7&scoped=true&"
import script from "./echart-bar.vue?vue&type=script&lang=js&"
export * from "./echart-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812b6c7",
  null
  
)

export default component.exports